import React, { useEffect, useRef } from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';

import CustomPagination from '../CustomPagination/CustomPagination';

export const CustomStatusBarPagination = ({ count, pageCountOverride }) => {
  const { page, onPageChange, limit = 25 } = useTableContext();
  const countRef = useRef(count);

  useEffect(() => {
    countRef.current = count;
  }, [count]);

  return (
    <div className="bg-red flex h-full flex-wrap items-center space-x-4 text-sm">
      {countRef.current > 0 ? (
        <CustomPagination
          onPageChange={onPageChange}
          perPage={limit}
          totalItems={countRef.current || 1}
          page={page}
          pageCountOverride={pageCountOverride}
        />
      ) : null}
    </div>
  );
};
